import { gql } from "@apollo/client";

export const CHANGE_PASSWORD = gql`
  query ChangePassword {
    changePassword {
      success
      message
    }
  }
`;
